<template>
  <Transition name="slide-fade" appear>
    <div v-if="visible" class="modal-end">
      <div class="modal-content">
        <div class="modal-top">
          <div class="modal-header">
            <span class="modal-header-txt">Create new group</span>
            <span class="modal-header-description">
             Create new group
            </span>

            <span class="form-label mt-3">Group Name</span>
            <input class="form-input" v-model="groupName" placeholder="Enter group name" />

            <span class="form-label mt-2">Select users</span>
            <multiselect v-model="userIds" :options="filteredUserList" track-by="id" label="name" :multiple="true" :internal-search="false" @search-change="onUserSearch">
              <template #noOptions>
                <span class="no-data-found">{{$t('no_data_found')}}</span>
              </template>
            </multiselect>

          </div>

          <div @click="this.onHide" class="close-btn">
            <img class="cross" src="../../assets/images/cross.svg" />
          </div>
        </div>

        <div class="modal-bottom">
          <button class="primary-button" :disabled="sendLoading" @click="handleCreateGroup">
            <VueSpinnerIos v-if="sendLoading" />
            <span v-else>{{$t('add')}}</span>
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Switch from "@/components/Switch.vue";
import {VueSpinnerIos} from 'vue3-spinners';
import FileDrop from "@/components/FileDrop.vue";
import journeyService from "@/service/journeyService";
import {formatBytes, handleErrorResponse} from "@/utils/utils";
import commonService from "@/service/commonService";
import socketChatService from "@/service/socketChatService";

export default {
  components: {
    FileDrop,
    Switch,
    Multiselect,
    VueSpinnerIos
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {}
    },
    notificationId: {
      type: String,
      default: ''
    },
    refreshCallback: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      sendLoading: false,
      userList: [],
      userIds: [],
      groupName: '',
      userSearchQuery: '',
    };
  },
  computed: {
    filteredUserList() {
      if (!this.userSearchQuery) {
        return this.userList;
      }
      const query = this.userSearchQuery.toLocaleLowerCase('tr');
      return this.userList.filter(user =>
        user.name && user.name.toLocaleLowerCase('tr').includes(query)
      );
    }
  },
  mounted() {
    commonService.getUsers().then(response => {
      this.userList = response.data.data.users.filter(user => user.name && user.name.trim() !== '');
      if (this.$route.query.userIds) {
        try {
          const tempUserIds = this.$route.query.userIds.split(',');

          this.userIds = this.userList.filter(user => {
            return tempUserIds.includes(user.id);
          });
        } catch (e) {}
      }
    }).catch(err => {
      handleErrorResponse(err, this.$snackbar);
    });
  },
  methods: {
    onUserSearch(query) {
      this.userSearchQuery = query;
    },
    handleCreateGroup() {
      if (!this.groupName || this.userIds.length === 0) {
        this.$snackbar.add({
          text: 'Please fill all fields',
          type: 'error',
        });
        return;
      }

      this.sendLoading = true;
      socketChatService.createChatGroup(
        this.groupName,
        this.userIds.map(user => user.id),
        this.notificationId,
      ).then(() => {
        this.sendLoading = false;
        this.refreshCallback();
        this.onHide();
        this.$snackbar.add({
          text: 'Group created successfully',
          type: 'success',
        });
      }).catch(err => {
        this.sendLoading = false;
        handleErrorResponse(err, this.$snackbar);
      });
    }
  },
};
</script>


<style scoped>

.modal-content {
  position: relative;
  background-color: white;
  width: 50%;
  height: 100%;
  border-radius: 12px;
  padding: 24px;
  overflow-y: auto;
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
}

.modal-content::-webkit-scrollbar {
  width: 15px;
}

.modal-content::-webkit-scrollbar-track {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #FFF;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: rgba(4, 12, 45, 0.2);
  border-radius: 10px;
  border: 5px transparent solid;
  background-clip: padding-box;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(4, 12, 45, 0.4);
}

.close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  background: none;
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 3000px;
}
.cross{
  padding: 8px;
}
.modal-header{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 0 10px 0;
  border: none;
}

.modal-header-txt{
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 18px;
  font-style: normal;
  line-height: 24px;
}
.modal-header-description {
  font-family: euclid_medium, sans-serif;
  color: #667085;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}
h5 {
  font-family: euclid_medium, sans-serif;
  color: #010511;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 20px;
}

.setting-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
}

.setting-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 5px;
}

.setting-name {
  font-family: euclid_medium, sans-serif;
  color: #060B27;
  font-size: 18px;
  font-style: normal;
  line-height: 20px;
}

.setting-text {
  color: #667085;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}

.modal-top {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.modal-bottom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-top: 40px;
}

.primary-button {
  display: flex;
  justify-content: center;
  align-items: center;
}

.file-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #E5E9F2;
  border-radius: 8px;
  padding: 10px;
}

.file-item .left {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.file-item .right {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.file-name {
  font-family: euclid_medium, sans-serif;
  color: #060B27;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}

.file-size {
  font-family: euclid_medium, sans-serif;
  color: #667085;
  font-size: 12px;
  font-style: normal;
  line-height: 20px;
}


</style>
